/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { ConstructionSite } from '@shared/models';
import { FileItem } from 'ng2-file-upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConstructionSiteDocumentService extends ApiClient {

  constructor(private httpClient: HttpClient) {
    super();
  }

  uploadDocument(constructionSiteId: string, uploadFile: FileItem, isVao: boolean): Observable<ConstructionSite> {
    return Observable.create((observer) => {
      uploadFile.url = `${environment.backendServer}${constructionSiteId}/documents?isVao=${isVao}`;
      uploadFile.withCredentials = false;
      uploadFile.upload();
      uploadFile.onProgress = () => {
        const fileUploadXhr = uploadFile._xhr;
        fileUploadXhr.onreadystatechange = () => {
          // wait until the XHR is done (readyState 4)
          if (fileUploadXhr.readyState === 4) {
            if (fileUploadXhr.status === 200 || fileUploadXhr.status === 201) {
              observer.next(JSON.parse(fileUploadXhr.response));
              observer.complete();
            } else {
              observer.error(fileUploadXhr.response);
            }
          }
        };
      };
    });
  }

  deleteDocument(constructionSite: ConstructionSite, documentIri: string): Observable<ConstructionSite> {
    const constructionSiteId = this.extractId(constructionSite['@id']);
    const documentId = this.extractId(documentIri);

    return this.httpClient
      .post<ConstructionSite>(
        `${environment.backendServer}/api/construction_sites/${constructionSiteId}/documents/${documentId}`,
        constructionSite,
        {
          headers: this.LD_JSON_HEADERS,
          observe: 'response'
        }
      ).pipe(
        map(response => response.body)
      );
  }
}
